var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { styled } from "@mui/system";
import { BottomNavigationComponent } from "../BottomNavigation";
import { useMediaQuery, useTheme } from "@mui/material";
const FooterWrapper = styled("footer")(({ theme }) => {
    return {
        display: "flex",
        padding: "1vw 1vw",
        paddingTop: "0.6vw",
        backgroundColor: "#ffffff",
        alignItems: "center",
        width: "100%",
        ".footer_left-section": {
            flex: 5,
            fontSize: ".7rem",
            whiteSpace: 'pre'
        },
        ".footer_middle-section": {
            flex: 6,
            fontSize: ".7rem",
        },
        ".footer_right-section": {
            flex: 3,
            fontSize: ".7rem",
            textAlign: "end",
            display: "flex",
            justifyContent: "end",
            marginRight: "10px",
            whiteSpace: "pre",
            ".footer_right-icon": {
                padding: "0px 5px",
                img: {
                    width: 35,
                },
            },
        },
        // Responsive
        [theme.breakpoints.between(768, 320)]: {
            footer: {
                marginBottom: "25vh",
            },
            ".footer_left-section": {
                textAlign: "center !important",
                whiteSpace: 'normal'
            },
        },
        [theme.breakpoints.down(900)]: {
            display: "inline-block",
            textAlign: "center",
            marginBottom: 56,
            ".footer_right-section": {
                textAlign: "center",
                display: "block",
                marginTop: "10px",
            },
        },
        [theme.breakpoints.down(770)]: {
            paddingBottom: "7vh",
            paddingTop: 15
        },
    };
});
export const Footer = (props) => {
    var _a, _b;
    const { label } = props, rest = __rest(props, ["label"]);
    const theme = useTheme();
    const showBottomNav = useMediaQuery(theme.breakpoints.down("md"));
    return (React.createElement(React.Fragment, null,
        React.createElement(FooterWrapper, Object.assign({}, rest),
            React.createElement("div", { className: "footer_left-section", style: props.leftSectionStyle }, props.leftSectionText),
            React.createElement("div", { className: "footer_middle-section", style: props.middleSectionStyle }, props.middleSectionText),
            React.createElement("div", { className: "footer_right-section", style: props.rightSectionStyle }, (props === null || props === void 0 ? void 0 : props.rightSectionText) ||
                ((_a = props === null || props === void 0 ? void 0 : props.rightSectionIconList) === null || _a === void 0 ? void 0 : _a.map((key) => {
                    return (React.createElement("a", { key: key.alt, className: "footer_right-icon", rel: "noreferrer", target: "_blank", href: key.link },
                        React.createElement("img", { alt: key.alt, src: key.image })));
                })))),
        showBottomNav && (props === null || props === void 0 ? void 0 : props.bottomNavgation) && (React.createElement(BottomNavigationComponent, { navigationlist: props === null || props === void 0 ? void 0 : props.bottomNavgation, style: (_b = props === null || props === void 0 ? void 0 : props.bottomNavgation) === null || _b === void 0 ? void 0 : _b.styleBottomNav }))));
};
